import { graphql } from 'react-relay';

export const deleteDrawingSetAnnotationMutation = graphql`
    mutation deleteDrawingSetAnnotationMutation($id: ID!) {
        deleteDrawingSetAnnotation(id: $id) {
            ...drawingSetAnnotationFragment
        }
    }
`;
